import { object, string, array } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
  add: array().of(string().required()).required(),
});

/**
 * ClientSubscribeEvent
 *
 * - Esse evento é enviado pelo cliente para iniciar a conexão com o servidor.
 * - O cliente deve enviar esse evento assim que a conexão for estabelecida.
 * - O servidor irá responder com um evento de `SystemSubscribe` contendo informações sobre a conexão.
 */
export class ClientSubscribeEvent extends CreateCommand(RealtimeEventType.ClientSubscribe, SCHEMA) {}
